import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Alert, Col, Row } from 'react-bootstrap';
import { patch, post } from 'helpers/api';

import ImportRequestsHeader from './import_request_header';
import ImportRequestDetails from './import_request_details';
import ImportsList from './imports/imports_list';
import CreateImportModal from './create_import_modal';
import CompletedSupportModal from './completed_support_modal';

export default function ImportRequestView({ importRequest, paths, supportStatusOptions }) {
  const [request, setRequest] = useState(importRequest);
  const [errors, setErrors] = useState([]);
  const [showCreateImport, setShowCreateImport] = useState(false);
  const [showCompletedSupport, setShowCompletedSupport] = useState(false);
  
  const updateImportRequest = (requestParams, onSuccess, onError) => {
    patch(paths.importRequest, { importRequest: requestParams })
      .then(({ importRequest }) => {
        onSuccess(importRequest);
      }).catch((errors) => {
        onError(errors);
      });
  };

  const handleCreateImport = (selectedFileIds) => {
    const params = {
      importerImport: { ownerType: 'data_imports_team' },
      selectedFileIds: selectedFileIds
    };

    post(paths.importRequestImports, params)
      .then((response) => {
        window.location.href = response.import.importPath;
      }).catch((errors) => {
        setErrors(errors);
      });
  };

  const handleNewImport = () => {
    setShowCreateImport(true);
  };

  const handleChangeSupportStatus = (status) => {
    if (request.supportStatus.value === status.value) {
      return;
    } else if (status.value === 'completed') {
      setShowCompletedSupport(true);
    } else {
      updateImportRequest({ supportStatus: status.value }, setRequest, setErrors);
    } 
  };

  const renderErrors = () => (
    errors && errors.length > 0 &&
    <Alert bsStyle="warning" name="errors-alert">
      {errors.map((error, i) => <div key={i}>{error}</div>)}
    </Alert>
  );

  return (
    <div className="container">
      <ImportRequestsHeader
        importRequest={request}
        requestsIndexPath={paths.importRequestsIndex}
        supportStatusOptions={supportStatusOptions}
        onSupportStatusChange={handleChangeSupportStatus}
      />
      {renderErrors()}
      <Row className="w-100">
        <Col lg={3} md={3} xs={12}>
          <ImportRequestDetails
            downloadRequestFilesPath={paths.downloadRequestFiles}
            importRequest={request}
          />
        </Col>
        <Col lg={9} md={9} xs={12}>
          <ImportsList
            imports={request.dataTeamImports}
            onNewImport={handleNewImport}
          />
        </Col>
      </Row>
      <CreateImportModal
        requestFiles={importRequest.files}
        shown={showCreateImport}
        onClose={() => setShowCreateImport(false)}
        onCreateImport={handleCreateImport}
      />
      <CompletedSupportModal
        request={importRequest}
        shown={showCompletedSupport}
        onChangeErrors={setErrors}
        onChangeRequest={setRequest}
        onClose={() => setShowCompletedSupport(false)}
        onUpdateImportRequest={updateImportRequest}
      />
    </div>
  );
}

ImportRequestView.propTypes = {
  importRequest: PropTypes.shape({
    clientNotes: PropTypes.string,
    dateSupportRequested: PropTypes.string,
    dataTeamImports: PropTypes.array,
    requestedBy: PropTypes.string,
    supportStatus: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  }).isRequired,
  paths: PropTypes.object.isRequired,
  supportStatusOptions: PropTypes.array.isRequired
};
